import { render, staticRenderFns } from "./AssetInbox.vue?vue&type=template&id=5e13c1a0&scoped=true&"
import script from "./AssetInbox.vue?vue&type=script&lang=js&"
export * from "./AssetInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13c1a0",
  null
  
)

export default component.exports